import { useMutation } from '@tanstack/react-query';
import { useHandleEmailLoginSuccess } from '#hooks';
import { authenticateUserWithEmailAndPassword } from '#utils';

type Data = Awaited<ReturnType<typeof authenticateUserWithEmailAndPassword>>;

export const useLogin = ({
  skipRedirect = false,
  onSuccess,
  onError,
  onSettled,
}: {
  skipRedirect?: boolean;
  onSuccess?: (data: Data) => void;
  onError?: (error: {
    status?: string;
    message?: string;
    code?: number;
  }) => void;
  onSettled?: () => void;
} = {}) => {
  const { handleEmailLoginSuccess } = useHandleEmailLoginSuccess({
    skipRedirect,
  });

  const {
    mutate: login,
    mutateAsync: loginAsync,
    isPending: isLoggingIn,
  } = useMutation({
    mutationFn: authenticateUserWithEmailAndPassword,
    onSuccess: async (data) => {
      if (onSuccess) {
        onSuccess(data);
      }

      await handleEmailLoginSuccess(data);
    },
    onError: (error) => {
      if (onError) onError(error);
    },
    onSettled: () => {
      if (onSettled) onSettled();
    },
  });

  return { login, loginAsync, isLoggingIn };
};
